import NoTargetIcon from '@material-ui/icons/DeviceHub';
import BatteryStdIcon from '@material-ui/icons/BatteryStd';
import SyncProblemIcon from '@material-ui/icons/SyncProblem';
import SignalCellularAltIcon from '@material-ui/icons/SignalCellularAlt';
import RouterIcon from '@material-ui/icons/Router';
import SyncIcon from '@material-ui/icons/Sync';
import { Filter } from '../../types';
import React from 'react';
import SearchIcon from '@material-ui/icons/Search';
import { Block, DeveloperMode } from '@material-ui/icons';

function toJSON(this: Filter): any {
  return {
    category: this.category,
    value: this.value,
  };
}

const wrappers: { [id: string]: (filter: Filter) => void } = {
  noTarget: (filter: Filter) => {
    filter.description = 'No webhooks set';
    filter.icon = <NoTargetIcon viewBox="-8 -4 32 32" />;
  },
  configurationWarning: (filter: Filter) => {
    filter.description = 'Configuration warning';
  },
  noGateway: (filter: Filter) => {
    filter.description = 'Unlinked sensors';
    filter.icon = <RouterIcon viewBox="-8 -4 32 32" />;
  },
  archived: (filter: Filter) => {
    filter.description = 'Show archived devices';
  },
  pendingChange: (filter: Filter) => {
    filter.description = 'Has pending changes';
    filter.icon = <SyncIcon viewBox="-8 -4 32 32" />;
  },
  serial_number_or_imei: (filter: Filter) => {
    filter.description = filter.value;
    filter.icon = <SearchIcon viewBox="-8 -4 32 32" />;
  },
  battery_voltage_health: (filter: Filter) => {
    const dm: { [id: string]: string } = {
      critical: 'Battery voltage critical',
      warning: 'Battery voltage low',
      ok: 'Battery voltage ok',
    };

    filter.description = dm[filter.value];
    filter.icon = <BatteryStdIcon viewBox="-8 -4 32 32" />;
  },
  battery_voltage_average_health: (filter: Filter) => {
    const dm: { [id: string]: string } = {
      critical: 'Average battery voltage critical',
      warning: 'Average battery voltage low',
      ok: 'Average battery voltage ok',
    };

    filter.description = dm[filter.value];
    filter.icon = <BatteryStdIcon viewBox="-8 -4 32 32" />;
  },
  signal_strength_health: (filter: Filter) => {
    const dm: { [id: string]: string } = {
      critical: 'Signal strength critical',
      warning: 'Signal strength low',
      ok: 'Signal strength ok',
    };

    filter.description = dm[filter.value];
    filter.icon = <SignalCellularAltIcon viewBox="-8 -4 32 32" />;
  },
  signal_strength_average_health: (filter: Filter) => {
    const dm: { [id: string]: string } = {
      critical: 'Average signal strength critical',
      warning: 'Average signal strength low',
      ok: 'Average signal strength ok',
    };

    filter.description = dm[filter.value];
    filter.icon = <SignalCellularAltIcon viewBox="-8 -4 32 32" />;
  },
  to_next_communication_at: (filter: Filter) => {
    filter.description = 'Behind on syncing schedule';
    filter.icon = <SyncProblemIcon viewBox="-8 -4 32 32" />;
  },

  from_next_communication_at: (filter: Filter) => {
    filter.description = 'Not behind on syncing schedule';
  },

  measurementGreaterThan: (filter: Filter) => {
    filter.description = 'Measurement greater than ' + filter.value;
    filter.icon = (
      <span
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '0px 4px',
          fontWeight: 500,
          minWidth: '20px',
          fontSize: '1.1rem',
          marginBottom: '-2px',
        }}
      >
        &#62;
      </span>
    );
  },

  measurementLessThan: (filter: Filter) => {
    filter.description = 'Measurement less than ' + filter.value;
    filter.icon = (
      <span
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '0px 4px',
          fontWeight: 500,
          minWidth: '20px',
          fontSize: '1.1rem',
          marginBottom: '-2px',
        }}
      >
        &#60;
      </span>
    );
  },

  measurementEquals: (filter: Filter) => {
    filter.description = 'Measurement equals to ' + filter.value;
    filter.icon = (
      <span
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '0px 4px',
          fontWeight: 500,
          minWidth: '20px',
          fontSize: '1.1rem',
          marginBottom: '-2px',
        }}
      >
        =
      </span>
    );
  },
  noSensors: (filter: Filter) => {
    filter.description = 'Unlinked gateways';
    filter.icon = <RouterIcon viewBox="-8 -4 32 32" />;
  },
  withGateway: (filter: Filter) => {
    filter.description = 'Linked sensors';
    filter.icon = <RouterIcon viewBox="-8 -4 32 32" />;
  },
  withSensors: (filter: Filter) => {
    filter.description = 'Linked gateways';
    filter.icon = <RouterIcon viewBox="-8 -4 32 32" />;
  },
  testDevice: (filter: Filter) => {
    filter.description = 'Only Test Device';
    filter.icon = <DeveloperMode viewBox="-8 -4 32 32" />;
  },
  excludeTestDevice: (filter: Filter) => {
    filter.description = 'Exclude Test Device';
    filter.icon = <DeveloperMode viewBox="-8 -4 32 32" />;
  },
  includeTestDevice: (filter: Filter) => {
    filter.description = 'Include Test Device';
    filter.icon = <DeveloperMode viewBox="-8 -4 32 32" />;
  },
  muted: (filter: Filter) => {
    filter.description = 'Only Muted Device';
    filter.icon = <Block viewBox="-8 -4 32 32" />;
  },
  excludeMuted: (filter: Filter) => {
    filter.description = 'Exclude Muted Device';
    filter.icon = <Block viewBox="-8 -4 32 32" />;
  },
  includeArchived: (filter: Filter) => {
    filter.description = 'Include Archived';
  },
  onlyArchived: (filter: Filter) => {
    filter.description = 'Only Archived';
  },
  includeStock: (filter: Filter) => {
    filter.description = 'Include Stock';
  },
  onlyStock: (filter: Filter) => {
    filter.description = 'Only Stock';
  },
};

const wrapFilters = (filters: Filter[]) => {
  const wrappedFilters = filters.map((filter: Filter) => {
    const wrapper = wrappers[filter.category];

    if (wrapper) {
      filter = {
        ...filter,
        toJSON,
      };
      wrapper(filter);
    }

    return filter;
  });

  return wrappedFilters;
};

export default wrapFilters;
